module.exports = __webpack_public_path__ + "static/media/mahogany.100ed172.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/mahogany.jpg
// module id = 842
// module chunks = 6